<template>
    <div class="table_wrap member">
        <span class="total_length pb10">총 {{ bannerData.length }}개 </span>
        <el-table class="list-table" header-cell-class-name="list-header"
                  style="width: 100%;" height="895" empty-text="데이터가 없습니다."
                  :data="bannerData"
        >
            <el-table-column label="PC이미지" min-width="1209" class-name="text-center">
                <template slot-scope="scope">
                    <div @click="changeType(`bannerData[${scope.$index}]Files`)">

                        <el-upload
                                class="avatar-uploader main-banner mr15"
                                :auto-upload="false"
                                action=""
                                :show-file-list="false"
                                list-type="picture"
                                :on-change="onlyOneFileUpload"
                                :disabled="!isEdit(scope.$index)"

                        >
                            <img v-if="hasFile(scope.row,'Files')" :src="returnBackImage(scope.row,'Files',1200,295)"
                                 class="avatar"
                            >
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            <button v-if="hasFile(scope.row,'Files') && isEdit(scope.$index)" class="cancelBtn"
                                    @click.stop="deleteBackImage(scope.row,'Files')"
                                    :disabled="!isEdit(scope.$index)"></button>
                        </el-upload>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="Mobile이미지" min-width="750" class-name="text-center">
                <template slot-scope="scope">
                    <div @click="changeType(`bannerData[${scope.$index}]MobileFiles`)">
                        <el-upload
                                class="avatar-uploader mobile-banner mr15"
                                :auto-upload="false"
                                action=""
                                :show-file-list="false"
                                list-type="picture"
                                :on-change="onlyOneFileUpload"
                                :disabled="!isEdit(scope.$index)"

                        >
                            <img v-if="hasFile(scope.row,'MobileFiles')"
                                 :src="returnBackImage(scope.row,'MobileFiles',710,384)"
                                 class="avatar"
                            >
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            <button v-if="hasFile(scope.row,'MobileFiles') && isEdit(scope.$index)" class="cancelBtn"
                                    @click.stop="deleteBackImage(scope.row,'MobileFiles')"
                                    :disabled="!isEdit(scope.$index)"></button>
                        </el-upload>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="이동" min-width="190" class-name="text-center" prop="">
                <template slot-scope="scope">
                    <div class="text_left">
                        <el-radio-group class="radioBox" v-model="scope.row.b_type" :disabled="!isEdit(scope.$index)"
                                        @change="changeRadio(scope.$index)">
                            <el-radio :label="'image'">미선택</el-radio>
                            <el-radio :label="'link'">외부링크</el-radio>
                        </el-radio-group>
                    </div>
                    <div class="radio_sub_box" v-if="scope.row.b_type === 'link'">
                        <el-input v-model="scope.row.b_url"
                                  :disabled="!isEdit(scope.$index)" @input="changeInput(scope.row.b_url)"
                                  :placeholder="'https://VNK.com'"></el-input>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="노출유무" min-width="150" class-name="text-center" prop="">
                <template slot-scope="scope">
                    <el-select class="" v-model="scope.row.b_is_display" :disabled="!isEdit(scope.$index)">
                        <el-option :value="0" :label="'미노출'"></el-option>
                        <el-option :value="1" :label="'노출'"></el-option>
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column
                    label="옵션" min-width="170" class-name="text-center">
                <template slot-scope="scope">
                    <div class="row-info">
                        <el-button class="reg_btn_out" @click="saveFunc(scope.row)" v-if="isEdit(scope.$index)">
                            저장
                        </el-button>
                        <el-button class="com_del" @click="deleteFunc(scope.row,scope.$index)"
                                   v-if="isEdit(scope.$index)">
                            삭제
                        </el-button>
                        <!--                        <el-button class="com_del" @click="changeState(scope.$index,false)" v-if="isEdit(scope.$index)">
                                                    취소
                                                </el-button>-->

                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>


<script>
import bannerUtil from "@/components/banner/bannerUtil";
import util from "@/mixins/util";
import EventBus from "@/utils/event-bus";
import alertMixins from "@/mixins/alertMixins";
import elFileMixins from "@/mixins/elFileMixins";
import imageOption from "@/mixins/imageOption";

export default {
    name: "BannerListDefaultLayout",
    mixins: [bannerUtil, alertMixins, elFileMixins, imageOption],
    inject: ['bannerListDelete', 'writeBanner'],
    components: {},
    provide() {
        return {}
    },
    props: {
        bannerData: {default: () => []},
        cityList: {default: () => []},
    },
    data() {
        return {
            bannerImage: [],
            fileType: '',
            checkState: [],
            modalSelNum: 0,
            selectIdx: 0,
            itemName: [],
            mediaDate: [],
            filterData: [],
            checkDate: false,
        }
    },
    created() {
    },
    mounted() {
        EventBus.$on('setBannerFilterDate', this.setBannerFilterDate)
        EventBus.$on('removeBannerFilterDate', this.removeBannerFilterDate)
    },
    beforeDestroy() {
        EventBus.$off('setBannerFilterDate')
        EventBus.$off('removeBannerFilterDate')
    },
    destroyed() {
    },
    computed: {},
    methods: {
        goDetail() {

        },
        parentChange(key, value) {
            // this.bannerListSetData(key, value)
        },
        returnImageList(banner) {
            if (this.hasFile(banner)) {
                return banner.Files
            } else return []
        },
        hasFile(banner, type) {
            return !util.isEmpty(banner) && banner.hasOwnProperty(`${type}`) && !util.isEmpty(banner[type])
        },
        returnBackImage(banner, type, width, height) {
            if (!this.hasFile(banner, type)) {
                return '';
            }
            return util.isEmpty(banner[type][0].org_url) ? banner[type][0].url : `${banner[type][0].org_url}?${this.setImageOptions(width, height, 'jpg')}`
            // return util.isEmpty(banner.Files[0].org_url) ? banner.Files[0].org_url : `${banner.Files[0].org_url}?${this.setImageOptions(width, height, 'jpg')}`
        },
        deleteBackImage(row, type) {
            if (!this.hasFile(row, type)) {
                return '';
            }
            console.log(row)
            console.log(type)
            row.deleteFiles = [];
            // row.deleteFiles.push(row.Files[0])
            row.deleteFiles.push(row[type][0])
            row[type] = []
        },


        onlyOneFileUpload(file, fileList) {
            let maxSize = this.imageMaxSize;
            let type = file.raw.type.split('/');
            file.name = this.regExp(file.name)
            if (file.size > maxSize) {
                this.errorAlert('1회 업로드 가능 ' + maxSize + '를 초과했습니다!');
                fileList.pop();
            } else if (!(type[1] === 'jpeg' || type[1] === 'png')) {
                this.errorAlert('이미지 파일만 업로드 가능합니다.')
                fileList.pop();
            } else {

                let dataFile = this.$_.get(this, `${this.fileType}`) //this.a.b[1]
                if (this.fileType === '' || dataFile === undefined) {
                    if (this.files.length > 0 && this.files[0].hasOwnProperty('a_idx') && this.files[0].a_idx != null) {
                        file.a_idx = this.files[0].a_idx;
                    }
                    this.files[0] = file;
                    this.$forceUpdate();
                    if (this.parentChange) {
                        this.parentChange('files', this.files);
                    }
                } else {
                    let dataFile = this.$_.get(this, `${this.fileType}`)
                    if (dataFile.length > 0 && dataFile[0].hasOwnProperty('a_idx') && dataFile[0].a_idx != null) {
                        file.a_idx = dataFile[0].a_idx;
                    }
                    //this[this.fileType][0] = file;
                    // let fileSetName =
                    this.$_.set(this, `${this.fileType}`, []);
                    this.$_.set(this, `${this.fileType}[0]`, file);
                    this.$forceUpdate();
                    if (this.parentChange) {
                        this.parentChange(this.fileType, this[this.fileType]);
                    }
                }
                // this.changeValidate();
            }
        },

        saveFunc(row) {
            if (!this.checkValidator(row)) {
                this.errorAlert('이미지를 넣어주세요')
                return false;
            }
            if (!this.checkLinkValidator(row)) {
                this.errorAlert('링크를 설정해주세요')
                return false;
            }
            if ((row.b_type === 'link' && !util.isEmpty(row.b_url) && !util.form.VTypes.url(row.b_url))) {
                this.errorAlert('올바른 링크를 입력해 주세요')
                return false;
            }
            let params = this.makeParams(row)
            let writeFunc = ''

            writeFunc = params.hasOwnProperty('b_idx') && !util.isEmpty(row.b_idx) ? 'updateBanner' : 'createBanner'
            this.createConfirm({
                content: '저장하시겠습니까?',
                confirm: () => {
                    this.writeBanner(params, writeFunc)
                }
            })
        },
        checkValidator(row) {
            return !(util.isEmpty(row.Files)) && !(util.isEmpty(row.MobileFiles));

        },
        checkLinkValidator(row) {
            return !(row.b_type === 'link' && util.isEmpty(row.b_url))
        },
        makeParams(row) {
            let params = {}
            params.b_is_display = row.b_is_display
            params.Files = row.Files
            params.MobileFiles = row.MobileFiles
            params.deleteFiles = row.deleteFiles
            params.b_category = 'mint'

            if (row.hasOwnProperty('b_idx') && !util.isEmpty(row.b_idx)) {
                params.b_idx = row.b_idx
            }
            if (row.b_type === 'image') {
                params.b_type = 'image'
            } else if (row.b_type === 'link') {
                params.b_type = row.b_type
                params.b_url = row.b_url
            }
            return params
        },

        deleteFunc(row, idx) {
            let key = row.hasOwnProperty('b_idx') && !util.isEmpty(row.b_idx) ? row.b_idx : ''
            if (!util.isEmpty(key)) {
                this.bannerListDelete(key, idx)
            } else {
                this.bannerData.splice(idx, 1)
                this.filterData.splice(idx, 1)
            }
        },
        updateConfirm(index, state) {
            this.createConfirm({
                content: '수정하시겠습니까?',
                confirm: () => {
                    this.changeState(index, state)
                }
            })
        },
        changeState(index, state) {
            if (state) {
                this.bannerData[index].origin = Object.assign({}, this.bannerData[index])
            } else {
                this.bannerData[index] = this.bannerData[index].origin
            }
            this.bannerData[index].c_type = state
            this.$set(this.bannerData, index, this.bannerData[index])
        },
        openModal(type, index) {
            let name = ''
            switch (type) {
                case 'edu':
                    name = 'banner-edu-list-modal'
                    break
                case 'agency':
                    name = 'banner-agency-list-modal'
                    break
                case 'notice':
                    name = 'banner-notice-list-modal'
                    break
                default:
                    name = ''
            }
            this.$modal.show(name)
            this.selectIdx = index

        },
        isEdit(index) {
            // return this.checkState[index]
            // return this.bannerData[index].c_type
            return true;
        },
        changeRadio(index) {
            this.bannerData[index].b_key = ''
            this.bannerData[index].b_url = ''
        },
        changeInput(v) {
            let t = util.form.VTypes.url(v)
            console.log(t)
        },
        setBannerFilterDate(data) {
            this.filterData.unshift(data);
        },
        removeBannerFilterDate(idx) {
            if (idx > -1) {
                this.filterData.splice(idx, 1);
            }
        },

    },

    watch: {},
}
</script>

<style scoped>

</style>
